/** Parses a comma-separated URL param into a list of non-empty ids. */
export const parseListingArrayParam = (param: string | null): string[] => {
  if (!param) return [];
  return param.split(',').filter(Boolean);
};
